package com.ervasstudio.tracoemovimento.pages.projecto

import androidx.compose.runtime.*
import com.ervasstudio.tracoemovimento.model.PopupState
import com.ervasstudio.tracoemovimento.model.UserRecoveryData
import com.ervasstudio.tracoemovimento.util.Res
import com.varabyte.kobweb.compose.css.FontWeight.Companion.Bold
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px


@Composable
fun UserRecoveryData(
    currentState: PopupState,
    isOpen: Boolean,
    onClose: () -> Unit,
    onSave: (UserRecoveryData) -> Unit,
    externalError: String? = null,
) {
    if (!isOpen) return

    // Estado do formulário vive aqui, no nível que NÃO desaparece
    // quando currentState muda entre FORM/LOADING/SUCCESS.
    var name by remember(isOpen) { mutableStateOf("") }
    var email by remember(isOpen) { mutableStateOf("") }
    var phone by remember(isOpen) { mutableStateOf("") }

    LaunchedEffect(currentState) {
        if (currentState == PopupState.SUCCESS) {
            delay(3000)
            onClose()
        }
    }

    Overlay(
        modifier = Modifier
            .backgroundColor(Colors.Black.copy(alpha = 400))
            .onClick { if (currentState != PopupState.LOADING) onClose() },
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier.width(400.px).position(Position.Relative),
            contentAlignment = Alignment.Center
        ) {
            Image(
                modifier = Modifier.fillMaxWidth().objectFit(ObjectFit.Fill),
                src = Res.Image.bgpopup,
            )
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(24.px)
                    .borderRadius(8.px)
                    .onClick { it.stopPropagation() },
                horizontalAlignment = Alignment.Start
            ) {
                when (currentState) {
                    PopupState.FORM -> {
                        FormLayout(
                            name = name,
                            email = email,
                            phone = phone,
                            onNameChange = { name = it },
                            onEmailChange = { email = it },
                            onPhoneChange = { phone = it },
                            onCancel = onClose,
                            onSave = { data -> onSave(data) },
                            externalError = externalError
                        )
                    }

                    PopupState.LOADING -> LoadingLayout()
                    PopupState.SUCCESS -> {
                        SuccessLayout()
                        // limpa só quando sucesso de facto
                        LaunchedEffect(Unit) {
                            name = ""; email = ""; phone = ""
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun FormLayout(
    name: String,
    email: String,
    phone: String,
    onNameChange: (String) -> Unit,
    onEmailChange: (String) -> Unit,
    onPhoneChange: (String) -> Unit,
    onCancel: () -> Unit,
    onSave: (UserRecoveryData) -> Unit,
    externalError: String? = null
) {
    var nameError by remember { mutableStateOf<String?>(null) }
    var emailError by remember { mutableStateOf<String?>(null) }
    var phoneError by remember { mutableStateOf<String?>(null) }
    var isSubmitting by remember { mutableStateOf(false) }

    val emailRegex = "^[A-Za-z0-9+_.-]+@(.+)\$".toRegex()
    val phoneRegex = "^8[2-7][0-9]{7}$".toRegex()

    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.Center) {
        SpanText(
            text = "Entrar na fila de espera",
            modifier = Modifier
                .textAlign(TextAlign.Center)
                .fontFamily("GothamBook")
                .fontSize(20.px)
                .fontWeight(Bold)
                .margin(bottom = 16.px)
        )
    }


    SpanText("Nome Completo", modifier = Modifier.fontFamily("GothamBook").fontSize(14.px).margin(bottom = 4.px))
    Input(
        type = InputType.Text,
        value = name,
        onValueChange = {
            onNameChange(it)
            if (nameError != null) nameError = null
        },
        placeholder = "Digite seu nome",
        modifier = Modifier.fillMaxWidth().margin(bottom = if (nameError != null) 2.px else 12.px)
    )
    nameError?.let {
        SpanText(
            it,
            Modifier.color(Colors.Red).fontSize(12.px).margin(bottom = 12.px).fontFamily("GothamBook")
        )
    }

    SpanText(
        "E-mail",
        modifier = Modifier
            .fontFamily("GothamBook")
            .fontSize(14.px)
            .margin(bottom = 4.px)
    )
    Input(
        type = InputType.Email,
        value = email,
        onValueChange = {
            onEmailChange(it)
            if (emailError != null) emailError = null
        },
        placeholder = "exemplo@email.com",
        modifier = Modifier.fillMaxWidth()
            .margin(bottom = if (emailError != null || externalError != null) 2.px else 12.px)
    )
    (emailError ?: externalError)?.let {
        SpanText(
            it,
            Modifier
                .color(Colors.Red)
                .fontSize(12.px)
                .margin(bottom = 12.px)
                .fontFamily("GothamBook")
        )
    }

    SpanText(
        "Celular / WhatsApp",
        modifier = Modifier
            .fontFamily("GothamBook")
            .fontSize(14.px)
            .margin(bottom = 4.px)
    )
    Input(
        type = InputType.Tel,
        value = phone,
        onValueChange = {
            onPhoneChange(it)
            if (phoneError != null) phoneError = null
        },
        placeholder = "+258 ...",
        modifier = Modifier.fillMaxWidth().margin(bottom = if (phoneError != null) 2.px else 24.px)
    )
    phoneError?.let {
        SpanText(
            it,
            Modifier.color(Colors.Red).fontSize(12.px).margin(bottom = 24.px).fontFamily("GothamBook")
        )
    }

    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
        Button(
            onClick = { onCancel() },
            modifier = Modifier.margin(right = 8.px)
        ) {
            SpanText("Cancelar", Modifier.fontFamily("GothamBook"))
        }

        Button(
            onClick = {
                if (isSubmitting) return@Button // evita duplo-submit

                var isValid = true
                if (name.trim().split("\\s+".toRegex()).size < 2) {
                    nameError = "Por favor, introduza o nome completo."
                    isValid = false
                }
                val normalizedEmail = email.trim().lowercase()
                if (!normalizedEmail.matches(emailRegex)) {
                    emailError = "Formato de e-mail inválido."
                    isValid = false
                }
                if (!phone.replace(" ", "").matches(phoneRegex)) {
                    phoneError = "Número de telefone inválido."
                    isValid = false
                }

                if (isValid) {
                    isSubmitting = true
                    onSave(UserRecoveryData(name.trim(), normalizedEmail, phone.trim()))
                }
            },
            modifier = Modifier.backgroundColor(Colors.DodgerBlue)
        ) {
            SpanText(
                if (isSubmitting) "Enviando..." else "Enviar",
                modifier = Modifier.fontFamily("GothamBook").color(Colors.White)
            )
        }
    }
}

@Composable
fun LoadingLayout() {
    Column(
        modifier = Modifier.fillMaxWidth().padding(top = 40.px, bottom = 40.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        // Você pode trocar por uma imagem de spinner .gif ou usar um texto estilizado
        SpanText(
            text = "Enviando seus dados...",
            modifier = Modifier.fontFamily("GothamBook").fontSize(18.px).margin(bottom = 8.px)
        )
        SpanText(
            text = "Por favor, aguarde.",
            modifier = Modifier.fontFamily("GothamBook").fontSize(14.px).color(Colors.Gray)
        )
    }
}

@Composable
fun SuccessLayout() {
    Column(
        modifier = Modifier.fillMaxWidth().padding(top = 40.px, bottom = 40.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        // Ícone de check ou imagem de sucesso
        SpanText(
            text = "Sucesso!",
            modifier = Modifier.fontFamily("GothamBook").fontSize(24.px).fontWeight(Bold).color(Colors.Green)
                .margin(bottom = 8.px)
        )
        SpanText(
            text = "Inscrição realizada com sucesso.",
            modifier = Modifier.fontFamily("GothamBook").fontSize(14.px)
        )
    }
}